import React, { Component, Fragment } from 'react'
import { CardBenefits, CardBenefitsMobile } from 'loyal-react'

import Netshoes from '@loyal_images/brand/cards-benefits/img_netshoes.png'
import DrogariaPacheco from '@loyal_images/brand/cards-benefits/img_drogaria_pacheco.png'
import ChinaInBox from '@loyal_images/brand/cards-benefits/img_chinainbox.png'
import Magalu from '@loyal_images/brand/cards-benefits/img_magalu.png'
import MediaQuery from 'react-responsive'

class DiscountSuggestion extends Component {
  render () {
    return (
      <Fragment>
        <MediaQuery maxDeviceWidth={425}>
          <CardBenefitsMobile
            link='https://clube.netshoes.com.br/especial/itaucard?campaign=netpro_b2b_itaucard&utm_source=b2b_itaucard&utm_medium=redirect-itaucard&utm_campaign=b2b_itaucard'
            name='Netshoes'
            profile='pra quem tem Itaucard'
            image={Netshoes}
            title='Vai para Netshoes'
            alt='Netshoes'
            titleImg='Imagem Netshoes'
          >
            <span>
              15% off
            </span>
          </CardBenefitsMobile>
          <CardBenefitsMobile
            link='https://www.itau.com.br/content/dam/itau/cartoes/beneficios/PDF_Beneficio_Farmacia.pdf'
            name='Drogaria Pacheco'
            profile='pra quem tem Itaucard'
            image={DrogariaPacheco}
            title='Vai para Drogaria Pacheco'
            alt='Drogaria Pacheco'
            titleImg='Imagem Drogaria Pacheco'
          >
            <span>Até 35% off</span>
          </CardBenefitsMobile>
          <CardBenefitsMobile
            link='https://www.chinainbox.com.br'
            name='China In Box'
            profile='pra quem tem Itaucard'
            image={ChinaInBox}
            title='Vai para China In Box'
            alt='China In Box'
            titleImg='Imagem China In Box'
          >
            <span>15% de <br />desconto</span>
          </CardBenefitsMobile>
          <CardBenefitsMobile
            link='https://clube2.magazineluiza.com.br/selecao-produtos/clube-220419/se/?ordem=mais-vendidos&utm_source=itau&utm_medium=banner&utm_campaign=ofertas&n=itau&is_clube=1&menu=1&parceiro=itau'
            name='Magalu'
            profile='pra quem tem Itaucard'
            image={Magalu}
            title='Vai para Magalu'
            alt='Magalu'
            titleImg='Imagem Magalu'
          >
            <span>Até 10% <br />de desconto</span>
          </CardBenefitsMobile>
        </MediaQuery>
        <MediaQuery minDeviceWidth={426}>
          <CardBenefits
            link='https://clube.netshoes.com.br/especial/itaucard?campaign=netpro_b2b_itaucard&utm_source=b2b_itaucard&utm_medium=redirect-itaucard&utm_campaign=b2b_itaucard'
            name='Netshoes'
            profile='pra quem tem Itaucard'
            image={Netshoes}
            title='Vai para Netshoes'
            alt='Netshoes'
            titleImg='Imagem Netshoes'
          >
            <span>
              15% off
            </span>
          </CardBenefits>
          <CardBenefits
            link='https://www.itau.com.br/content/dam/itau/cartoes/beneficios/PDF_Beneficio_Farmacia.pdf'
            name='Drogaria Pacheco'
            profile='pra quem tem Itaucard'
            image={DrogariaPacheco}
            title='Vai para Drogaria Pacheco'
            alt='Drogaria Pacheco'
            titleImg='Imagem Drogaria Pacheco'
          >
            <span>Até 35% off</span>
          </CardBenefits>
          <CardBenefits
            link='https://www.chinainbox.com.br'
            name='China In Box'
            profile='pra quem tem Itaucard'
            image={ChinaInBox}
            title='Vai para China In Box'
            alt='China In Box'
            titleImg='Imagem China In Box'
          >
            <span>15% off com cupom <br />15ITAUCHINA. Min R$30</span>
          </CardBenefits>
          <CardBenefits
            link='https://clube2.magazineluiza.com.br/selecao-produtos/clube-220419/se/?ordem=mais-vendidos&utm_source=itau&utm_medium=banner&utm_campaign=ofertas&n=itau&is_clube=1&menu=1&parceiro=itau'
            name='Magalu'
            profile='pra quem tem Itaucard'
            image={Magalu}
            title='Vai para Magalu'
            alt='Magalu'
            titleImg='Imagem Magalu'
          >
            <span>Até 10% <br />de desconto</span>
          </CardBenefits>
          <CardBenefits link='' name='' description='' image='' />
        </MediaQuery>
      </Fragment>
    )
  }
}

export default DiscountSuggestion



// WEBPACK FOOTER //
// ./src/features/Benefits/DiscountSuggestion/DiscountSuggestion.js